require('waypoints/lib/jquery.waypoints.js')

/*
 * Animate smooth scroll for anchor links. Optional data-speed attribute can
 * be used to determine speed of animation (defaults to 400ms)
 */
$('.js-jump-link').on('click', function (e) {
  e.preventDefault()

  var t = $(this)
  var indexOfHash = t.attr('href').indexOf('#')

  if (indexOfHash < 0) return false;

  // Identify anchor portion of URL
  var anchor = t.attr('href').indexOf('#') > 0 ? '#' + t.attr('href').split('#')[1] : t.attr('href')
  var target = $(anchor)

  if (target.length) {
    var speed = t.data('speed') ? t.data('speed') : 400
    var offset = 0

    /*
     * If data-offset attribute provides valid element selector, offset scroll point by
     * height of specified element (prevents start of content sitting underneath fixed elements)
     */
    if (t.data('offset')) {
      var offsetEl = $(t.data('offset'))
      if (offsetEl.length) offset = offsetEl.outerHeight() + 10
    }
    var scrollTo = target.offset().top - offset

    $('body, html').animate({ scrollTop: scrollTo + 'px'}, speed)
  }
})


// Fix jump nav element to top of viewport when its container hits top of viewport:
var jumpNav = $('#js-jump-nav')
if (jumpNav.length) {

  jumpNav.waypoint ({
    handler: function (direction) {
      if (direction === 'up') {
        jumpNav.removeClass('js-sticky')
      } else {
        jumpNav.addClass('js-sticky')
      }
    }
  })

}

// Fade to top link in and out based on distance from top of main content area
var toTopLink = $('.js-top-link')
if (toTopLink.length) {

  // If scrolled 60% of viewport height past top of content, show to top link:
  $('#main-content').waypoint({
    handler: function (direction) {
      if (direction === 'up') {
        toTopLink.removeClass('js-sticky')
      } else {
        toTopLink.addClass('js-sticky')
      }
    },
    offset: '-60%'
  })

}
